import { axiosClient } from '../utils/axiosClient.js';
import * as Paths from '@/components/common/paths';
import { handleServerError } from '@/components/common/errorUtils';
import i18n from '@/i18n';

// 翻訳キーから値を取得するヘルパー関数
const t = (key) => {
    try {
        return i18n.global.t(key);
    } catch (e) {
        return '';
    }
};

const actions = {
    async login({ dispatch }, loginData) {
        try {
            const response = await axiosClient.post(Paths.LOGIN_URL, loginData);
            const data = response.data;

            if (data.type === 0) {
                dispatch('dataManagement/setOperatorInfo', data.result, { root: true });
                localStorage.setItem('api_token', data.result.api_token);
                
                return { success: true, operatorId: data.result.operator_id };
            } else {
                console.error('Unexpected data type:', data.type);
                return { success: false, error: 'Unexpected data type' };
            }
        } catch (error) {
            console.error(handleServerError(error),error);
            return { success: false, error: t('errors.login_failed') };
        }
    },
};

export default {
    namespaced: true,
    actions,
};
